/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  NormalizedCacheObject,
  createHttpLink,
  from,
} from "@apollo/client";
import merge from "deepmerge";
import isEqual from "lodash/isEqual";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";
import { useMemo } from "react";
import { WebSocketLink } from "@apollo/client/link/ws";
// const typeDefs = gql`
//   extend type Query {
//     draftComplaints: [Complaint]
//   }
// `;
let apolloClient: ApolloClient<NormalizedCacheObject>;
const accessToken = Cookies.get("x-access-token");
let tokenIsValid = false;
if (accessToken) {
  try {
    const decoded = jwtDecode(accessToken || "") as any;
    if (decoded.exp * 1000 < Date.now()) {
      Cookies.remove("x-access-token");
      tokenIsValid = false;
    } else {
      tokenIsValid = true;
    }
  } catch (err) {
    Cookies.remove("x-access-token");
  }
}
function createApolloClient() {
  const authLink = new ApolloLink((operation, forward) => {
    if (accessToken && tokenIsValid) {
      operation.setContext(({ headers = {} }) => ({
        headers: {
          ...headers,
          authorization: `Bearer ${accessToken}`,
        },
      }));
    }
    return forward(operation);
  });
  const wsLink = new WebSocketLink({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT_WS || "",
    lazy: true,
    options: {
      reconnect: true,
      connectionParams:
        accessToken && tokenIsValid
          ? {
              headers: {
                authorization: `Bearer ${accessToken}`,
              },
            }
          : {},
    },
  });
  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
  });

  return new ApolloClient({
    ssrMode: typeof window === "undefined",
    link: from([authLink, httpLink, wsLink]),
    cache: new InMemoryCache(),
  });
}

export function InitializeApollo(
  initialState: any = null,
): ApolloClient<NormalizedCacheObject> {
  const _apolloClient = apolloClient ?? createApolloClient();
  if (initialState) {
    const existingCache = _apolloClient.extract();
    // Merge the existing cache into data passed from getStaticProps/getServerSideProps
    const data = merge(initialState, existingCache, {
      // combine arrays using object equality (like in sets)
      arrayMerge: (destinationArray, sourceArray) => [
        ...sourceArray,
        ...destinationArray.filter((d) =>
          sourceArray.every((s) => !isEqual(d, s)),
        ),
      ],
    });
    _apolloClient.cache.restore(data);
  }
  if (typeof window === "undefined") return _apolloClient;
  if (!apolloClient) apolloClient = _apolloClient;
  return _apolloClient;
}
export const APOLLO_STATE_PROP_NAME = "__APOLLO_STATE__";
export function useApollo(pageProps: any) {
  const state = pageProps[APOLLO_STATE_PROP_NAME];
  const store = useMemo(() => InitializeApollo(state), [state]);
  return store;
}
export function addApolloState(client: any, pageProps: any) {
  if (pageProps?.props) {
    pageProps.props[APOLLO_STATE_PROP_NAME] = client.cache.extract();
  }

  return pageProps;
}
